import { useIntl } from "react-intl";
import { UserPreferenceKey } from "../../../../common/api/decimal/methods/user.ts";
import { BookBanner } from "../../common/onboarding-banner/BookBanner.tsx";
import { useRecentRecommendationsLoaderData } from "../dashboardLoader.ts";
import { Suspense } from "react";
import { Await } from "react-router-dom";
import useIsRecommendationsNew from "../../common/recommendations/useIsRecommendationsNew.ts";

export default function RecommendationsBanner() {
  const intl = useIntl();
  const loaderData = useRecentRecommendationsLoaderData();
  const isRecommendationsNew = useIsRecommendationsNew();

  if (isRecommendationsNew) {
    return (
      <Suspense
        fallback={
          <div>
            {/* This makes this banner "visible" while it's still loading,
               holding its place in the priority queue */}
          </div>
        }
      >
        <Await resolve={loaderData}>
          {(response: Awaited<typeof loaderData>) => {
            if (response.ok && response.data) {
              return (
                <BookBanner
                  badgeText={intl.formatMessage({
                    defaultMessage: "New Feature",
                  })}
                  noMargin
                  title={intl.formatMessage({
                    defaultMessage: "Review Recommendations From Publishers",
                  })}
                  body={intl.formatMessage({
                    defaultMessage:
                      "You can now easily access recommendations sent from publishers in Home. Simply add the free sample to My Library and gain full access to see if it’s a good fit for your course.",
                  })}
                  linkText={intl.formatMessage({ defaultMessage: "View" })}
                  to="/recommendations"
                  bannerSeenPreferenceKey={
                    UserPreferenceKey.DashboardRecommendationsBannerDismissed
                  }
                  vbids={response.data.map((book) => book.manageAsset.vbid)}
                />
              );
            }
          }}
        </Await>
      </Suspense>
    );
  }
}
